import { useEffect, useState } from "preact/hooks";
import { api } from "./api";
import { Login } from "./screens/Login";
import { Onboarding } from "./screens/Onboarding";
import { TabBar, type TabKey } from "./components/TabBar";
import { Today } from "./screens/Today";
import { Log } from "./screens/Log";
import { Diary } from "./screens/Diary";
import { Train } from "./screens/Train";
import { Body } from "./screens/Body";
import { Routine } from "./screens/Routine";
import { Coach } from "./screens/Coach";

type Phase = "loading" | "login" | "onboarding" | "app";

export function App() {
  const [phase, setPhase] = useState<Phase>("loading");
  const [tab, setTab] = useState<TabKey>("today");
  const [reloadKey, setReloadKey] = useState(0); // bump to refetch day-scoped data

  async function bootstrap() {
    const { authed } = await api.session();
    if (!authed) { setPhase("login"); return; }
    const p = await api.profile();
    setPhase(p.onboarded ? "app" : "onboarding");
  }

  useEffect(() => { bootstrap().catch(() => setPhase("login")); }, []);

  if (phase === "loading") {
    return (
      <div class="center-screen">
        <div class="brand-row"><img src="/icons/icon.svg" alt="" /><span class="name">Hickman Health</span></div>
      </div>
    );
  }
  if (phase === "login") return <Login onAuthed={() => { setPhase("loading"); bootstrap(); }} />;
  if (phase === "onboarding") return <Onboarding onDone={() => { setPhase("loading"); bootstrap(); }} />;

  function onLogged() {
    setReloadKey((k) => k + 1);
    setTab("today");
  }

  async function logout() {
    try { await api.logout(); } catch { /* ignore */ }
    setTab("today");
    setPhase("login");
  }

  return (
    <>
      {tab === "today" && <Today reloadKey={reloadKey} onGoLog={() => setTab("log")} onLogout={logout} onChanged={() => setReloadKey((k) => k + 1)} />}
      {tab === "log" && <Log onLogged={onLogged} />}
      {tab === "diary" && <Diary reloadKey={reloadKey} />}
      {tab === "train" && <Train reloadKey={reloadKey} onLogged={() => setReloadKey((k) => k + 1)} />}
      {tab === "body" && <Body reloadKey={reloadKey} />}
      {tab === "routine" && <Routine reloadKey={reloadKey} onChanged={() => setReloadKey((k) => k + 1)} />}
      {tab === "coach" && <Coach reloadKey={reloadKey} />}
      <TabBar active={tab} onChange={setTab} />
    </>
  );
}
